import { useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'

export const useIconSize = (): 'Small' | 'Medium' => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  return isArcadeDesignLanguage ? 'Medium' : 'Small'
}
